import * as yup from "yup";

export const EmployeeTD1FormValidationSchema = yup.object({
  effectiveDate: yup
    .string()
    .required("Effective Date is required"),
});
